import React from 'react';
import { connect } from 'react-redux';
// import { isMobileBrowser } from '../../base/environment/utils';
import { translate, translateToHTML } from '../../base/i18n/functions';
import Icon from '../../base/icons/components/Icon';
import { IconWarning } from '../../base/icons/svg';
import Watermarks from '../../base/react/components/web/Watermarks';
import getUnsafeRoomText from '../../base/util/getUnsafeRoomText.web';
// import CalendarList from '../../calendar-sync/components/CalendarList.web';
// import RecentList from '../../recent-list/components/RecentList.web';
import { openSettingsDialog } from '../../settings/actions.web';
import SettingsButton from '../../settings/components/web/SettingsButton';
import { SETTINGS_TABS } from '../../settings/constants';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
// import Tabs from './Tabs';
/**
 * The pattern used to validate room name.
 *
 * @type {string}
 */
export const ROOM_NAME_VALIDATE_PATTERN_STR = '^[^?&:\u0022\u0027%#]+$';
const HERO_BACKGROUND_STYLE = {
    background: 'radial-gradient(900px circle at 20% 20%, rgba(1,164,255,0.35), transparent 60%),\n'
        + 'radial-gradient(700px circle at 80% 30%, rgba(124,58,237,0.25), transparent 55%),\n'
        + 'radial-gradient(900px circle at 50% 90%, rgba(16,185,129,0.15), transparent 60%)'
};
/**
 * The Web container rendering the welcome page.
 *
 * @augments AbstractWelcomePage
 */
class WelcomePage extends AbstractWelcomePage {
    _additionalContentRef;
    _additionalToolbarContentRef;
    _additionalCardRef;
    _roomInputRef;
    _additionalCardTemplate;
    _additionalContentTemplate;
    _additionalToolbarContentTemplate;
    _titleHasNotAllowCharacter;
    /**
     * Default values for {@code WelcomePage} component's properties.
     *
     * @static
     */
    static defaultProps = {
        _room: ''
    };
    /**
     * Initializes a new WelcomePage instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            generateRoomNames: interfaceConfig.GENERATE_ROOMNAMES_ON_WELCOME_PAGE ? 'enabled' : undefined
        };
        /**
      * Used To display a warning massage if the title input has no allow character.
      *
      * @private
      * @type {boolean}
      */
        this._titleHasNotAllowCharacter = false;
        /**
         * The HTML Element used as the container for additional content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentRef = null;
        this._roomInputRef = null;
        /**
         * The HTML Element used as the container for additional toolbar content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentRef = null;
        this._additionalCardRef = null;
        /**
         * The template to use as the additional card displayed near the main one.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalCardTemplate = document.getElementById('welcome-page-additional-card-template');
        /**
         * The template to use as the main content for the welcome page. If
         * not found then only the welcome page head will display.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentTemplate = document.getElementById('welcome-page-additional-content-template');
        /**
         * The template to use as the additional content for the welcome page header toolbar.
         * If not found then only the settings icon will be displayed.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentTemplate = document.getElementById('settings-toolbar-additional-content-template');
        // Bind event handlers so they are only bound once per instance.
        this._onFormSubmit = this._onFormSubmit.bind(this);
        this._onRoomChange = this._onRoomChange.bind(this);
        this._setAdditionalCardRef = this._setAdditionalCardRef.bind(this);
        this._setAdditionalContentRef
            = this._setAdditionalContentRef.bind(this);
        this._setRoomInputRef = this._setRoomInputRef.bind(this);
        this._setAdditionalToolbarContentRef
            = this._setAdditionalToolbarContentRef.bind(this);
        this._renderFooter = this._renderFooter.bind(this);
        this._onOpenSettings = this._onOpenSettings.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();
        document.body.classList.add('welcome-page');
        document.title = interfaceConfig.APP_NAME;
        if (this.state.generateRoomNames) {
            this._updateRoomName();
        }
        if (this._shouldShowAdditionalContent()) {
            this._additionalContentRef?.appendChild(this._additionalContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalToolbarContent()) {
            this._additionalToolbarContentRef?.appendChild(this._additionalToolbarContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalCard()) {
            this._additionalCardRef?.appendChild(this._additionalCardTemplate?.content.cloneNode(true));
        }
    }
    /**
     * Removes the classname used for custom styling of the welcome page.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        super.componentWillUnmount();
        document.body.classList.remove('welcome-page');
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        const { _moderatedRoomServiceUrl, t } = this.props;
        const { DEFAULT_WELCOME_PAGE_LOGO_URL, DISPLAY_WELCOME_FOOTER } = interfaceConfig;
        const showAdditionalToolbarContent = this._shouldShowAdditionalToolbarContent();
        const footerClassName = DISPLAY_WELCOME_FOOTER ? 'with-footer' : 'without-footer';
        return (React.createElement("div", { className: `welcome ${footerClassName}`, id: 'welcome_page' },
            React.createElement("div", { className: 'h-screen w-screen bg-slate-950 text-white' },
                React.createElement("div", { className: 'relative overflow-hidden' },
                    React.createElement("div", { className: 'pointer-events-none absolute inset-0 opacity-30', style: HERO_BACKGROUND_STYLE }),
                    React.createElement("div", { className: 'h-full w-full px-6 py-8' },
                        React.createElement("div", { className: 'flex items-center justify-between' },
                            React.createElement("div", { className: 'flex items-center gap-3' },
                                React.createElement("div", { className: 'h-10 w-10 rounded-xl bg-white/10 p-2 ring-1 ring-white/15' },
                                    React.createElement(Watermarks, { defaultJitsiLogoURL: DEFAULT_WELCOME_PAGE_LOGO_URL, noMargins: true })),
                                React.createElement("div", null,
                                    React.createElement("div", { className: 'text-sm font-semibold tracking-wide text-white/90' }, "LeQube Visio"),
                                    React.createElement("div", { className: 'text-xs text-white/60' }, "Outil de visioconf\u00E9rence int\u00E9gr\u00E9"))),
                            React.createElement("div", { className: 'flex items-center gap-3' },
                                React.createElement("button", { className: 'hidden items-center justify-center rounded-xl bg-white/10 px-4 py-2 text-sm font-semibold text-white ring-1 ring-white/15 transition hover:bg-white/15 md:inline-flex', onClick: this._onOpenSettings, type: 'button' }, t('toolbar.Settings')),
                                React.createElement("div", { className: 'welcome-page-settings' },
                                    React.createElement(SettingsButton, { defaultTab: SETTINGS_TABS.VIDEO, isDisplayedOnWelcomePage: true }),
                                    showAdditionalToolbarContent
                                        ? React.createElement("div", { className: 'settings-toolbar-content', ref: this._setAdditionalToolbarContentRef })
                                        : null))),
                        React.createElement("div", { className: 'mx-auto mt-14 grid max-w-7xl gap-12 lg:grid-cols-12 lg:items-center' },
                            React.createElement("div", { className: 'lg:col-span-7' },
                                React.createElement("div", { className: 'inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-semibold text-white/80 ring-1 ring-white/15' },
                                    React.createElement("span", { className: 'h-2 w-2 rounded-full bg-[#01A4FF]' }),
                                    t('welcomepage.headerSubtitle')),
                                React.createElement("h1", { className: 'mt-6 text-4xl font-bold leading-tight tracking-tight sm:text-5xl' }, "LeQube visio"),
                                React.createElement("p", { className: 'mt-5 text-base leading-7 text-white/70' }, "La solution tout-en-un pour piloter votre activit\u00E9. G\u00E9rez, automatisez, formez. La visio LeQube est disponible dans votre environnement, avec des param\u00E8tres simples et centralis\u00E9s."),
                                React.createElement("div", { className: 'mt-8 flex flex-col gap-3 sm:flex-row sm:items-center' },
                                    React.createElement("button", { className: 'inline-flex items-center justify-center rounded-2xl bg-[#01A4FF] px-6 py-3 text-sm font-bold text-slate-950 shadow-lg shadow-[#01A4FF]/30 transition hover:brightness-110', onClick: this._onOpenSettings, type: 'button' }, "Configurer la visio"),
                                    React.createElement("a", { className: 'inline-flex items-center justify-center rounded-2xl bg-white/10 px-6 py-3 text-sm font-semibold text-white ring-1 ring-white/15 transition hover:bg-white/15', href: 'https://le-qube.app/', rel: 'noopener noreferrer', target: '_blank' }, "D\u00E9couvrir LeQube")),
                                _moderatedRoomServiceUrl && (React.createElement("div", { className: 'mt-6 rounded-2xl bg-white/5 p-4 text-sm text-white/70 ring-1 ring-white/10' }, translateToHTML(t, 'welcomepage.moderatedMessage', { url: _moderatedRoomServiceUrl })))),
                            React.createElement("div", { className: 'lg:col-span-5' },
                                React.createElement("div", { className: 'rounded-3xl bg-white/5 p-6 ring-1 ring-white/10' },
                                    React.createElement("div", { className: 'text-sm font-semibold text-white/90' }, "Points cl\u00E9s"),
                                    React.createElement("div", { className: 'mt-4 grid gap-3' },
                                        React.createElement("div", { className: 'rounded-2xl bg-white/5 p-4 ring-1 ring-white/10' },
                                            React.createElement("div", { className: 'text-sm font-semibold' }, "Visio int\u00E9gr\u00E9e"),
                                            React.createElement("div", { className: 'mt-1 text-sm text-white/70' }, "Une exp\u00E9rience de r\u00E9union simple, int\u00E9gr\u00E9e \u00E0 votre solution.")),
                                        React.createElement("div", { className: 'rounded-2xl bg-white/5 p-4 ring-1 ring-white/10' },
                                            React.createElement("div", { className: 'text-sm font-semibold' }, "Param\u00E8tres centralis\u00E9s"),
                                            React.createElement("div", { className: 'mt-1 text-sm text-white/70' }, "Audio/vid\u00E9o et pr\u00E9f\u00E9rences accessibles en un clic.")),
                                        React.createElement("div", { className: 'rounded-2xl bg-white/5 p-4 ring-1 ring-white/10' },
                                            React.createElement("div", { className: 'text-sm font-semibold' }, "S\u00E9curit\u00E9"),
                                            React.createElement("div", { className: 'mt-1 text-sm text-white/70' }, "Une base solide, pr\u00EAte pour des usages professionnels.")))))))))));
    }
    /**
     * Renders the insecure room name warning.
     *
     * @inheritdoc
     */
    _doRenderInsecureRoomNameWarning() {
        return (React.createElement("div", { className: 'insecure-room-name-warning' },
            React.createElement(Icon, { src: IconWarning }),
            React.createElement("span", null, getUnsafeRoomText(this.props.t, 'welcome'))));
    }
    _onOpenSettings() {
        const { dispatch } = this.props;
        dispatch(openSettingsDialog(SETTINGS_TABS.VIDEO, true));
    }
    /**
     * Prevents submission of the form and delegates join logic.
     *
     * @param {Event} event - The HTML Event which details the form submission.
     * @private
     * @returns {void}
     */
    _onFormSubmit(event) {
        event.preventDefault();
        if (!this._roomInputRef || this._roomInputRef.reportValidity()) {
            this._onJoin();
        }
    }
    /**
     * Overrides the super to account for the differences in the argument types
     * provided by HTML and React Native text inputs.
     *
     * @inheritdoc
     * @override
     * @param {Event} event - The (HTML) Event which details the change such as
     * the EventTarget.
     * @protected
     */
    // @ts-ignore
    // eslint-disable-next-line require-jsdoc
    _onRoomChange(event) {
        const specialCharacters = ['?', '&', ':', '\'', '"', '%', '#', '.'];
        this._titleHasNotAllowCharacter = specialCharacters.some(char => event.target.value.includes(char));
        super._onRoomChange(event.target.value);
    }
    /**
     * Renders the footer.
     *
     * @returns {ReactElement}
     */
    _renderFooter() {
        const { t, _deeplinkingCfg: { ios = { downloadLink: undefined }, android = {
            fDroidUrl: undefined,
            downloadLink: undefined
        } } } = this.props;
        const { downloadLink: iosDownloadLink } = ios;
        const { fDroidUrl, downloadLink: androidDownloadLink } = android;
        return (React.createElement("footer", { className: 'welcome-footer' },
            React.createElement("div", { className: 'welcome-footer-centered' },
                React.createElement("div", { className: 'welcome-footer-padded' },
                    React.createElement("div", { className: 'welcome-footer-row-block welcome-footer--row-1' },
                        React.createElement("div", { className: 'welcome-footer-row-1-text' }, t('welcomepage.jitsiOnMobile')),
                        React.createElement("a", { className: 'welcome-badge', href: iosDownloadLink, rel: 'noopener noreferrer', target: '_blank' },
                            React.createElement("img", { alt: t('welcomepage.mobileDownLoadLinkIos'), src: './images/app-store-badge.png' })),
                        React.createElement("a", { className: 'welcome-badge', href: androidDownloadLink, rel: 'noopener noreferrer', target: '_blank' },
                            React.createElement("img", { alt: t('welcomepage.mobileDownLoadLinkAndroid'), src: './images/google-play-badge.png' })),
                        React.createElement("a", { className: 'welcome-badge', href: fDroidUrl, rel: 'noopener noreferrer', target: '_blank' },
                            React.createElement("img", { alt: t('welcomepage.mobileDownLoadLinkFDroid'), src: './images/f-droid-badge.png' })))))));
    }
    /**
     * Renders tabs to show previous meetings and upcoming calendar events. The
     * tabs are purposefully hidden on mobile browsers.
     *
     * @returns {ReactElement|null}
     */
    _renderTabs() {
        // Désactiver l'affichage des onglets pour la page LeQube
        return null;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * additional card shown near the tabs card.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalCardRef(el) {
        this._additionalCardRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * welcome page content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalContentRef(el) {
        this._additionalContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * toolbar additional content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the additional toolbar content.
     * @private
     * @returns {void}
     */
    _setAdditionalToolbarContentRef(el) {
        this._additionalToolbarContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLInputElement used to hold the
     * welcome page input room element.
     *
     * @param {HTMLInputElement} el - The HTMLElement for the input of the room name on the welcome page.
     * @private
     * @returns {void}
     */
    _setRoomInputRef(el) {
        this._roomInputRef = el;
    }
    /**
     * Returns whether or not an additional card should be displayed near the tabs.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalCard() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD
            && this._additionalCardTemplate?.content
            && this._additionalCardTemplate?.innerHTML?.trim();
    }
    /**
     * Returns whether or not additional content should be displayed below
     * the welcome page's header for entering a room name.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalContent() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT
            && this._additionalContentTemplate?.content
            && this._additionalContentTemplate?.innerHTML?.trim();
    }
    /**
     * Returns whether or not additional content should be displayed inside
     * the header toolbar.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalToolbarContent() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT
            && this._additionalToolbarContentTemplate?.content
            && this._additionalToolbarContentTemplate?.innerHTML.trim();
    }
}
export default translate(connect(_mapStateToProps)(WelcomePage));
